import { ChangeEvent } from "react";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

interface CellTextFieldProps {
  value: string;
  /** A viewed document shows its figures as text, the way they were saved. */
  readOnly: boolean;
  /** What a read-only cell shows, e.g. money with two decimals; the value itself otherwise. */
  displayValue?: string;
  ariaLabel: string;
  placeholder?: string;
  isNumeric?: boolean;
  width?: number | string;
  maxLength?: number;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const NUMERIC_INPUT_STYLE = { textAlign: "right" } as const;

/** One cell of a lines grid: a small input while keyed, plain text once the document is viewed. */
export default function CellTextField({
  value,
  readOnly,
  displayValue,
  ariaLabel,
  placeholder,
  isNumeric = false,
  width = "100%",
  maxLength,
  onChange,
}: Readonly<CellTextFieldProps>) {
  if (readOnly) {
    return (
      <Typography variant="body2" textAlign={isNumeric ? "right" : "left"}>
        {displayValue ?? value}
      </Typography>
    );
  }

  return (
    <TextField
      size="small"
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      sx={{ width }}
      slotProps={{
        htmlInput: {
          "aria-label": ariaLabel,
          maxLength,
          inputMode: isNumeric ? "decimal" : undefined,
          style: isNumeric ? NUMERIC_INPUT_STYLE : undefined,
        },
      }}
    />
  );
}
